import { z } from "zod";
import { ZDate } from "./ZDate.js";
import { zArr, zNum, zObj, zOptional } from "./zodWrapper.js";
export const Vessel = zObj({
    plantId: zNum(),
    mmsi: zNum(),
});
export const GetVesselInfoArgs = zObj({
    vessels: zArr(Vessel),
});
export const GetVesselConnectionStatusArgs = z.object({
    plantIds: z.array(z.number()),
});
export const VesselConnectionStatus = z.object({
    plantId: z.number(),
    latestTimestamp: z.nullable(ZDate),
    errorMessage: z.nullable(z.string()),
});
export const VesselInfoOperation = zObj({
    plantId: zNum(),
    vessel: zOptional(z.unknown()),
    position: zOptional(z.unknown()),
});
export const VesselInfoOperationCollection = zArr(VesselInfoOperation);
export const GetVesselTrackArgs = z.object({
    plantId: z.number(),
    interval: z.object({
        t1: ZDate,
        t2: ZDate,
    }),
});
export const VesselTrack = z.object({
    locations: z.array(z.object({
        timestamp: ZDate,
        latitude: z.number(),
        longitude: z.number(),
        course: z.nullable(z.number()),
        heading: z.nullable(z.number()),
        speed: z.nullable(z.number()),
    })),
});
export const GetDataSourceStatusArgs = z.object({ plantId: z.number() });
export const GetDataSourceStatusResponse = z.object({
    timestamp: ZDate,
    constraint: z.string(),
});
//# sourceMappingURL=vesselInfo.js.map